import {
  SET_USER_ACT_SEARCH_CRITERIA,
  CLEAR_USER_ACT_SEARCH_CRITERIA,
} from '../actions/actionTypes';

import { pageSize } from '../../pages/UserActivity/constants';

const initialState = {
  limit: pageSize,
  offset: 0,
  sort: '-createdOn',
};

const userActSearchCriteriaReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_ACT_SEARCH_CRITERIA:
      return {
        ...state,
        ...action.payload,
      };
    case CLEAR_USER_ACT_SEARCH_CRITERIA:
      return initialState;
    default:
      return state;
  }
};

export default userActSearchCriteriaReducer;
